// 员工角色列表
export const STAFF_ROLES = ['staff'];

// 所有任务角色
export const TASK_ROLES = ['staff'];

// 角色中文标签
export const ROLE_LABELS = {
  super_admin: '超级管理员',
  operator: '运营管理员',
  staff: '普通员工',
};

// 日报状态标签
export const STATUS_LABELS = {
  pending: '待处理',
  in_progress: '进行中',
  submitted: '已提交',
  reviewed: '已查阅',
  no_record: '未开始',
};

// 状态对应的 tag type
export const STATUS_TAG_TYPE = {
  pending: 'info',
  in_progress: 'warning',
  submitted: 'success',
  reviewed: '',
  no_record: 'info',
};

// 角色对应的 tag type
export const ROLE_TAG_TYPE = {
  super_admin: 'danger',
  operator: 'primary',
  staff: 'info',
};

// 班次标签
export const SHIFT_LABELS = {
  morning: '早班',
  evening: '晚班',
};

export const SHIFT_TAG_TYPE = {
  morning: '',
  evening: 'warning',
};

/**
 * 判断是否为普通员工角色
 */
export function isStaffRole(role) {
  return role === 'staff';
}

/**
 * 计算用户有效权限集（与后端 getUserPermissions 逻辑保持一致）
 * - extra_permissions 非空时直接使用
 * - 否则使用角色默认权限
 */
export function computePermissions(userInfo) {
  if (Array.isArray(userInfo?.extra_permissions) && userInfo.extra_permissions.length > 0) {
    return new Set(userInfo.extra_permissions);
  }
  return new Set(ROLE_PERMISSIONS[userInfo?.role] || []);
}

// 管理员类权限（非 my_tasks 的权限）
export const ADMIN_PERMISSIONS = [
  'inventory:read', 'inventory:write',
  'orders:read', 'orders:write',
  'cutting_board', 'samples', 'patch_fabric',
  'analytics',
  'patterns:read', 'patterns:write',
  'crawler',
  'miniapp_users:read', 'miniapp_users:write',
  'sales_contacts',
  'daily_tasks:read', 'daily_tasks:write',
  'notices',
  'system',
];

// 权限分组（用于权限设置 UI）
export const PERMISSION_GROUPS = [
  {
    group: '库存管理',
    items: [
      { value: 'inventory:read',  label: '查看库存（现货/预售/明细）' },
      { value: 'inventory:write', label: '编辑库存（新增/修改/删除）' },
    ],
  },
  {
    group: '订单管理',
    items: [
      { value: 'orders:read',  label: '查看订单（含定制单）' },
      { value: 'orders:write', label: '编辑订单/发货' },
      { value: 'cutting_board', label: '裁布工作台' },
      { value: 'samples',       label: '小样管理' },
      { value: 'patch_fabric',  label: '布块管理' },
    ],
  },
  {
    group: '数据分析',
    items: [
      { value: 'analytics', label: '预警/洞察/监控/客户意向' },
    ],
  },
  {
    group: '花型管理',
    items: [
      { value: 'patterns:read',  label: '查看花型库' },
      { value: 'patterns:write', label: '编辑花型库' },
      { value: 'crawler',        label: '爬虫操作' },
    ],
  },
  {
    group: '小程序用户',
    items: [
      { value: 'miniapp_users:read',  label: '查看用户' },
      { value: 'miniapp_users:write', label: '封禁/解封' },
    ],
  },
  {
    group: '销售线索',
    items: [
      { value: 'sales_contacts', label: '客户管理/销售线索' },
    ],
  },
  {
    group: '通知公告',
    items: [
      { value: 'notices', label: '发布/管理公告' },
    ],
  },
  {
    group: '系统管理',
    items: [
      { value: 'system', label: '账号与权限管理' },
    ],
  },
  {
    group: '账期管理',
    items: [
      { value: 'payable', label: '供应商/应付账单/付款记录' },
    ],
  },
];

// 角色对应的默认权限（与后端 config/roles.js 保持一致）
export const ROLE_PERMISSIONS = {
  super_admin: ['inventory:read','inventory:write','orders:read','orders:write','cutting_board','samples','patch_fabric','analytics','patterns:read','patterns:write','crawler','miniapp_users:read','miniapp_users:write','sales_contacts','daily_tasks:read','daily_tasks:write','my_tasks','notices','system','payable'],
  operator:    ['inventory:read','inventory:write','orders:read','orders:write','cutting_board','samples','patch_fabric','analytics','patterns:read','patterns:write','crawler','miniapp_users:read','miniapp_users:write','sales_contacts','my_tasks','notices','payable'],
  staff:       ['patterns:read','sales_contacts','my_tasks'],
};

// 权限预设方案（一键填充用）
export const PERMISSION_PRESETS = [
  { code: 'super_admin', name: '超级管理员', description: '全部权限', tagType: 'danger'  },
  { code: 'operator',    name: '运营管理员', description: '库存·订单·裁布·小样·布块·花型·爬虫·分析·用户·线索·任务面板·公告', tagType: 'primary' },
  { code: 'staff',       name: '普通员工',   description: '个人任务·销售线索·查看花型库', tagType: 'info'    },
];

// 任务模板角色选项（员工岗位，与登录角色无关）
export const TASK_ROLE_OPTIONS = [
  { value: 'sales',     label: '面料销售' },
  { value: 'anchor',    label: '主播' },
  { value: 'assistant', label: '运营助理' },
  { value: 'content',   label: '内容运营' },
  { value: 'warehouse', label: '仓库专员' },
];

// 员工岗位列表（用于任务模板/日报展示，与登录角色 staff 无关）
export const STAFF_JOB_ROLES = TASK_ROLE_OPTIONS.map(o => o.value);

// 员工岗位标签映射
export const JOB_ROLE_LABELS = Object.fromEntries(TASK_ROLE_OPTIONS.map(o => [o.value, o.label]));

// 员工岗位 tag 颜色
export const JOB_ROLE_TAG_TYPE = {
  sales:     '',
  anchor:    'warning',
  assistant: 'primary',
  content:   'success',
  warehouse: 'info',
};
